module.exports = __webpack_public_path__ + "img/objSerialNumber.ca3530d9.svg";